export default __webpack_public_path__ + "static/media/audioCodec@2x.98d7f31a.png";